import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmLink } from '../interfaces/IKnmLink';

export async function fetchKnmAbrogationLinks(id: number): Promise<IKnmLink[]> {
  return apiGet<IKnmLink[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/abrogationLinks`);
}
